import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { Clients } from "@/lib/clients";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { Tables } from "@/gen/tableNames/tables";

const filterE2PositionsSchema = z.object({
  strategy_from_id_equals: z.string().optional(),
  strategy_to_id_equals: z.string().optional(),
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterE2PositionsSchema = z.infer<typeof filterE2PositionsSchema>;
const filterE2PositionsFields = filterE2PositionsSchema.keyof().enum;

export function FilterE2Positions() {
  const { t } = useTranslation("tables");

  const fields: Field[] = [
    {
      name: filterE2PositionsFields.strategy_from_id_equals,
      label: t(`${Tables.E2_POSITIONS}.searchbox.strategy_from_id_equals`, {
        defaultValue: "Stratégie source (id)",
      }),
      type: "input",
    },
    {
      name: filterE2PositionsFields.strategy_to_id_equals,
      label: t(`${Tables.E2_POSITIONS}.searchbox.strategy_to_id_equals`, {
        defaultValue: "Stratégie cible (id)",
      }),
      type: "input",
    },
    {
      name: "date",
      type: "dateRange",
      label: "Date",
      from: { name: filterE2PositionsFields.date_from },
      to: { name: filterE2PositionsFields.date_to },
      copy_from_to_when_to_empty: true,
      col_span: 2,
    },
  ];

  return (
    <FilterTable
      columns={2}
      client={Clients.E2}
      schema={filterE2PositionsSchema}
      tableName={`${Tables.E2_POSITIONS}`}
      fields={fields}
    />
  );
}
